import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RegisterUser } from '@/store/actions';

const initialSignupState = {
  isLoading: false,
  result: null,
  message: '',
  registerUser:''
};


// Async thunk action
export const getRegisterUser: any = createAsyncThunk<any, any>(
  'signup/registerUser',
  async (payload: any) => {
    return payload; // Simulate API call or logic here
  },
);


export const signupSlice = createSlice({
  name: 'signup',
  initialState: initialSignupState,
  reducers: {
    clearSignupState: (state: any) => {
      state.isLoading = false;
      state.result = null;
      state.message = '';
    },
  },
  extraReducers: (builder: any) => {
    builder
      .addCase(RegisterUser.pending, (state: any) => {
 
         state.isLoading = true;
      })
      .addCase(getRegisterUser.fulfilled, (state: any, { payload }: any) => {
 
        state.registerUser = payload;
      })
      
      .addCase(RegisterUser.fulfilled, (state: any, { payload }: any) => {
        

        state.isLoading = false;
        state.result = payload.result;
        state.message = payload.message;
      })
      .addCase(RegisterUser.rejected, (state: any, { error }: any) => {
      
        state.isLoading = true;
        state.result = null;
        state.message = error.message || 'Registration failed';
      });
  },
});

export const { clearSignupState } = signupSlice.actions;
export default signupSlice.reducer;
